module.exports = __webpack_public_path__ + "164851bbd530fdfcb39a4c5fd455cb97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/co2.svg
// module id = 744
// module chunks = 0